import Box from "@mui/material/Box/Box";
import Container from "@mui/material/Container/Container";
import Grid from "@mui/material/Grid/Grid";
import { useContext } from "react";
import { AppContext } from "../context";




export const Footer = () => {
  const {logo} = useContext<any>(AppContext);

  return (
    <Box >
      <Container sx={{color: 'primary.main', marginTop: '35px'}} maxWidth='md'>
        <Grid container sx={{
          justifyContent: 'center',
          alignItems: 'center',
          
        }}>
          <Grid  item xs={8} sm={6} sx={{display: 'flex', justifyContent: 'center'}}>
            <img src={logo} height='40px' alt='logo' />
          </Grid>
          <Grid  item xs={8} sm={6} sx={{display: 'flex', justifyContent: 'center'}}>
            <p> Powered by <strong>Bria</strong></p>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
};


